module.exports = __webpack_public_path__ + "static/media/fundo-medicos.271bca4d.jpg";